import {
  Body,
  Button,
  CustomLink,
  Flex,
  LazyImage,
  Modal,
  Shape,
  styled,
} from '@teko/ds-desktop';
import { ChevronForwardFilled } from '@teko/ds-icon';
import { YoutubeFrame } from 'components/YoutubeFrame';
import { t } from 'i18n';
import React, { useState } from 'react';

export const RelatedBlock: React.FC<{
  type: string;
  seeMoreUrl?: string;
  items: Array<{ url: string; thumbnailUrl: string; description: string }>;
}> = (props) => {
  const [youtubeLink, setYoutubeLink] = useState<string>();
  const { type, seeMoreUrl, items } = props;

  const renderItem = (url: string, description: string) => {
    return (
      <Flex align="start">
        <LazyImage height="113px" cover borderRadius={8} src={url} />
        <Shape width="80%">
          <Body weight="medium" line={4} level={1} marginLeft="s12">
            {description}
          </Body>
        </Shape>
      </Flex>
    );
  };
  return (
    <>
      <Shape style={{ minHeight: 420 }}>
        <Flex gap="s16" direction="column" marginTop="s12">
          {items.map((item, index) => {
            const { url, thumbnailUrl, description } = item;
            return type === 'post' ? (
              <StyledCustomLink
                href={url}
                target="_blank"
                key={`${index}${url}`}
              >
                {renderItem(thumbnailUrl, description)}
              </StyledCustomLink>
            ) : (
              <Shape
                onClick={() => setYoutubeLink(url)}
                style={{ cursor: 'pointer', width: '100%' }}
                key={`${index}${url}`}
              >
                {renderItem(thumbnailUrl, description)}
              </Shape>
            );
          })}
        </Flex>
        {!!seeMoreUrl && (
          <CustomLink href={seeMoreUrl} target="_blank">
            <Flex
              style={{
                position: 'absolute',
                bottom: 20,
              }}
              align="center"
              justify="center"
              width="100%"
            >
              <Button variant="link">
                {t('Xem thêm')}
                <ChevronForwardFilled />
              </Button>
            </Flex>
          </CustomLink>
        )}
      </Shape>

      <Modal
        visible={!!youtubeLink}
        width="960px"
        onClose={() => setYoutubeLink('')}
        showCloseIcon={false}
        footer={false}
        contentStyle={{ padding: '0px' }}
      >
        <IFramePopupWrapper>
          <YoutubeFrame youtubeLink={youtubeLink} />
        </IFramePopupWrapper>
      </Modal>
    </>
  );
};

const StyledCustomLink = styled(CustomLink)`
  width: 100%;
`;

const IFramePopupWrapper = styled.div`
  width: 100%;
  height: 540px;
  background-color: black;
`;
